import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 10,
  },
  overlay: {
    opacity: 0.5,
  },
  list: {
    paddingBottom: 20,
  },
});
